import React from 'react'
import SEO from '../../seo/SEO'
import EventsBanner from './EventsBanner/EventsBanner'
import EventList from './EventList/EventList'

const EventsMain = () => {
  return (
    <>
  <SEO />
    <div>
        <EventsBanner/>
        <EventList/>
    </div>
    </>
  )
}

export default EventsMain